<!-- crm新能源行业解决方案模块 -->

<template>
  <div class="crmNewEnergy_solution_box">
    <div class="sheets_box">
      <div class="sheet_content" :style="{
        'background-image': 'url(' + bgData + ')',
        backgroundSize: '100% 100%',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center center',
        width: '1344px',
        height: '766px',
      }" :class="{ title_en: $i18n.locale === 'en_US' || $i18n.locale === 'ja_JP' }">
        <!-- 标题行 -->
        <div class="text_title title_height display_center" style="width: 1197px;top: 0.5rem; left: 0rem">
          {{ $t("solution_crm.new-energy.solutions.image.top.title") }}
        </div>
        <div class="text_title title_height display_center" style="width: 128px;top: 0.5rem; right: 0rem">
          {{ $t("solution_crm.new-energy.solutions.image.right.title") }}
        </div>
        <div class="text_title title_height display_center" style="width: 533px;top: 15rem; left: 0rem">
          {{ $t("solution_crm.new-energy.solutions.image.left_top.title") }}
        </div>
        <div class="text_title title_height display_center" style="width:275px; top: 15rem;left: 55.2rem">
          {{ $t("solution_crm.new-energy.solutions.image.right_top_01.title") }}
        </div>
        <div class="text_title title_height display_center" style="width: 195px;top: 15rem;right: 30.3rem;">
          {{ $t("solution_crm.new-energy.solutions.image.right_top_02.title") }}
        </div>
        <div class="text_title title_height display_center" style="width: 135px;top: 15rem;right: 14.8rem;">
          {{ $t("solution_crm.new-energy.solutions.image.right_top_03.title") }}
        </div>
        <div class="text_title title_height display_center" style="width: 240px;top: 29.2rem; left: 0rem">
          {{
            $t("solution_crm.new-energy.solutions.image.left_cneter_01.title")
          }}
        </div>
        <div class="text_title title_height display_center" style="width: 273px;top: 29.2rem; left: 26rem">
          {{
            $t("solution_crm.new-energy.solutions.image.left_cneter_02.title")
          }}
        </div>
        <div class="text_title title_height display_center" style="width: 300px;top: 50rem; left: 0rem">
          {{
            $t("solution_crm.new-energy.solutions.image.left_bottom_01.title")
          }}
        </div>
        <div class="text_title title_height display_center" style="width: 178px;top: 50rem; left: 32rem">
          {{
            $t("solution_crm.new-energy.solutions.image.left_bottom_02.title")
          }}
        </div>
        <div class="text_title title_height display_center" style="width: 358px;top: 50rem; left: 52rem">
          {{
            $t("solution_crm.new-energy.solutions.image.right_bottom_01.title")
          }}
        </div>
        <div class="text_title title_height display_center" style="width: 300px;top: 50rem; right: 14.8rem">
          {{
            $t("solution_crm.new-energy.solutions.image.right_bottom_02.title")
          }}
        </div>
        <!-- 倒数第一行 白字 -->
        <div class="text_white bottom_text display_dir_row">
          <div class="bottom_text_width display_center">
            {{ $t("solution_crm.new-energy.solutions.image.bottom.title1") }}
          </div>
          <div class="bottom_text_width display_center">
            {{ $t("solution_crm.new-energy.solutions.image.bottom.title2") }}
          </div>
          <div class="bottom_text_width display_center">
            {{ $t("solution_crm.new-energy.solutions.image.bottom.title3") }}
          </div>
          <div class="bottom_text_width display_center">
            {{ $t("solution_crm.new-energy.solutions.image.bottom.title4") }}
          </div>
        </div>
        <!-- 第一行 决策分析 -->
        <div class="text_normal top_01 display_dir_row">
          <div class="top_01_width display_center">
            {{ $t("solution_crm.new-energy.solutions.image.top.desc01") }}
          </div>
          <div class="top_01_width display_center">
            {{ $t("solution_crm.new-energy.solutions.image.top.desc02") }}
          </div>
          <div class="top_01_width display_center">
            {{ $t("solution_crm.new-energy.solutions.image.top.desc03") }}
          </div>
          <div class="top_01_width display_center">
            {{ $t("solution_crm.new-energy.solutions.image.top.desc04") }}
          </div>
          <div class="top_01_width display_center">
            {{ $t("solution_crm.new-energy.solutions.image.top.desc05") }}
          </div>
          <div class="top_01_width display_center">
            {{ $t("solution_crm.new-energy.solutions.image.top.desc06") }}
          </div>
          <div class="top_01_width display_center">
            {{ $t("solution_crm.new-energy.solutions.image.top.desc07") }}
          </div>
        </div>
        <!--  第二行 运营管理、市场管理、销售管理部分-->
        <div class="text_normal left_01 display_dir_row">
          <div class="left_01_width display_center">
            {{ $t("solution_crm.new-energy.solutions.image.left_top.desc01") }}
          </div>
          <div class="left_01_width display_center">
            {{ $t("solution_crm.new-energy.solutions.image.left_top.desc02") }}
          </div>
          <div class="left_01_width display_center">
            {{ $t("solution_crm.new-energy.solutions.image.left_top.desc03") }}
          </div>
        </div>
        <div class="text_normal left_02 display_dir_col">
          <div class="display_dir_row">
            <div class="left_02_width display_center">
              {{
                $t("solution_crm.new-energy.solutions.image.left_cneter_01.desc01")
              }}
            </div>
            <div class="left_02_width display_center">
              {{
                $t("solution_crm.new-energy.solutions.image.left_cneter_01.desc02")
              }}
            </div>
          </div>
          <div class="display_dir_row">
            <div class="left_02_width display_center">
              {{
                $t("solution_crm.new-energy.solutions.image.left_cneter_01.desc03")
              }}
            </div>
          </div>
        </div>
        <div class="text_normal left_03 display_dir_col">
          <div class="display_dir_row">
            <div class="left_03_width display_center">
              {{
                $t("solution_crm.new-energy.solutions.image.left_cneter_02.desc01")
              }}
            </div>
            <div class="left_03_width display_center">
              {{
                $t("solution_crm.new-energy.solutions.image.left_cneter_02.desc02")
              }}
            </div>
          </div>
          <div class="display_dir_row">
            <div class="left_03_width display_center">
              {{
                $t("solution_crm.new-energy.solutions.image.left_cneter_02.desc03")
              }}
            </div>
            <div class="left_03_width display_center">
              {{
                $t("solution_crm.new-energy.solutions.image.left_cneter_02.desc04")
              }}
            </div>
          </div>
        </div>

        <!-- 合同订单管理 -->
        <div class="text_normal text_normal2 right_04 display_dir_col">
          <div class="display_dir_row">
            <div class="right_04_width display_center">
              {{
                $t("solution_crm.new-energy.solutions.image.right_top_01.desc01")
              }}
            </div>
            <div class="right_04_width display_center">
              {{
                $t("solution_crm.new-energy.solutions.image.right_top_01.desc02")
              }}
            </div>
          </div>
          <div class="display_dir_row">
            <div class="right_04_width display_center">
              {{
                $t("solution_crm.new-energy.solutions.image.right_top_01.desc03")
              }}
            </div>
            <div class="right_04_width display_center">
              {{
                $t("solution_crm.new-energy.solutions.image.right_top_01.desc04")
              }}
            </div>
          </div>
          <div class="display_dir_row">
            <div class="right_04_width display_center">
              {{
                $t("solution_crm.new-energy.solutions.image.right_top_01.desc05")
              }}
            </div>
            <div class="right_04_width display_center">
              {{
                $t("solution_crm.new-energy.solutions.image.right_top_01.desc06")
              }}
            </div>
          </div>
          <div class="display_dir_row">
            <div class="right_04_width display_center">
              {{
                $t("solution_crm.new-energy.solutions.image.right_top_01.desc07")
              }}
            </div>
            <div class="right_04_width display_center">
              {{
                $t("solution_crm.new-energy.solutions.image.right_top_01.desc08")
              }}
            </div>
          </div>
        </div>
        <!-- 开票回款部分 -->
        <div class="text_normal text_normal2 right_03 display_dir_col">
          <div class="right_03_width display_center">
            {{
              $t("solution_crm.new-energy.solutions.image.right_top_02.desc01")
            }}
          </div>
          <div class="right_03_width display_center">
            {{
              $t("solution_crm.new-energy.solutions.image.right_top_02.desc02")
            }}
          </div>
          <div class="right_03_width display_center">
            {{
              $t("solution_crm.new-energy.solutions.image.right_top_02.desc03")
            }}
          </div>
          <div class="right_03_width display_center">
            {{
              $t("solution_crm.new-energy.solutions.image.right_top_02.desc04")
            }}
          </div>
        </div>
        <!-- 订单预测部分 -->
        <div class="text_normal text_normal2 right_02 display_dir_col">
          <div class="right_02_width display_center">
            {{
              $t("solution_crm.new-energy.solutions.image.right_top_03.desc01")
            }}
          </div>
          <div class="right_02_width display_center">
            {{
              $t("solution_crm.new-energy.solutions.image.right_top_03.desc02")
            }}
          </div>
          <div class="right_02_width display_center">
            {{
              $t("solution_crm.new-energy.solutions.image.right_top_03.desc03")
            }}
          </div>
        </div>
        <!--  客户管理、竞争对手、产品管理、用户/权限 -->
        <div class="text_normal bottom_01 display_dir_col">
          <div class="display_dir_row">
            <div class="bottom_01_width display_center">
              {{
                $t("solution_crm.new-energy.solutions.image.left_bottom_01.desc01")
              }}
            </div>
            <div class="bottom_01_width display_center">
              {{
                $t("solution_crm.new-energy.solutions.image.left_bottom_01.desc02")
              }}
            </div>
          </div>
          <div class="display_dir_row">
            <div class="bottom_01_width display_center">
              {{
                $t("solution_crm.new-energy.solutions.image.left_bottom_01.desc03")
              }}
            </div>
            <div class="bottom_01_width display_center">
              {{
                $t("solution_crm.new-energy.solutions.image.left_bottom_01.desc04")
              }}
            </div>
          </div>
        </div>
        <div class="text_normal bottom_02 display_dir_col">
          <div class="bottom_02_height display_center">
            {{
              $t("solution_crm.new-energy.solutions.image.left_bottom_02.desc01")
            }}
          </div>
          <div class="bottom_02_height display_center">
            {{
              $t("solution_crm.new-energy.solutions.image.left_bottom_02.desc02")
            }}
          </div>
        </div>
        <div class="text_normal bottom_03 display_dir_col">
          <div class="display_dir_row">
            <div class="bottom_03_width display_center">
              {{
                $t("solution_crm.new-energy.solutions.image.right_bottom_01.desc01")
              }}
            </div>
            <div class="bottom_03_width display_center">
              {{
                $t("solution_crm.new-energy.solutions.image.right_bottom_01.desc02")
              }}
            </div>
          </div>
          <div class="display_dir_row">
            <div class="bottom_03_width display_center">
              {{
                $t("solution_crm.new-energy.solutions.image.right_bottom_01.desc03")
              }}
            </div>
            <div class="bottom_03_width display_center">
              {{
                $t("solution_crm.new-energy.solutions.image.right_bottom_01.desc04")
              }}
            </div>
          </div>
        </div>
        <div class="text_normal bottom_04 display_dir_col">
          <div class="display_dir_row">
            <div class="bottom_04_width display_center">
              {{
                $t("solution_crm.new-energy.solutions.image.right_bottom_02.desc01")
              }}
            </div>
            <div class="bottom_04_width display_center">
              {{
                $t("solution_crm.new-energy.solutions.image.right_bottom_02.desc02")
              }}
            </div>
          </div>
          <div class="display_dir_row">
            <div class="bottom_04_width display_center">
              {{
                $t("solution_crm.new-energy.solutions.image.right_bottom_02.desc03")
              }}
            </div>
            <div class="bottom_04_width display_center">
              {{
                $t("solution_crm.new-energy.solutions.image.right_bottom_02.desc04")
              }}
            </div>
          </div>
        </div>
        <!-- 最后一列 移动端 -->
        <div class="text_normal text_normal2 right_01 display_dir_col">
          <div class="right_01_width display_center">
            {{ $t("solution_crm.new-energy.solutions.image.right.desc01") }}
          </div>
          <div class="right_01_width display_center">
            {{ $t("solution_crm.new-energy.solutions.image.right.desc02") }}
          </div>
          <div class="right_01_width display_center">
            {{ $t("solution_crm.new-energy.solutions.image.right.desc03") }}
          </div>
          <div class="right_01_width display_center">
            {{ $t("solution_crm.new-energy.solutions.image.right.desc04") }}
          </div>
          <div class="right_01_width display_center">
            {{ $t("solution_crm.new-energy.solutions.image.right.desc05") }}
          </div>
          <div class="right_01_width right_01_height display_center">
            {{ $t("solution_crm.new-energy.solutions.image.right.desc06") }}
          </div>
          <div class="right_01_width display_center">
            {{ $t("solution_crm.new-energy.solutions.image.right.desc07") }}
          </div>
          <div class="right_01_width display_center">
            {{ $t("solution_crm.new-energy.solutions.image.right.desc08") }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'crmNewEnergySolution',
  data () {
    return {
      bgData: require('../../../../assets/images/IndustrySolution/crm/newEnergy/newEnergy_solution_bg.png'),
    }
  }
}
</script>